import React from 'react';

function VMCDROMPanel({
  cdrom,
  cdromLoading,
  cdromMsg,
  selectedISOs,
  onClose,
  onSelectISO,
  onApply,
}) {
  return (
    <div className="cdrom-panel">
      <div className="cdrom-panel-header">
        <span className="cdrom-title">💿 CD/DVD Drive{cdrom.drives.length > 1 ? 's' : ''}</span>
        <button className="cdrom-close-btn" onClick={onClose} title="Fechar">✕</button>
      </div>
      {cdrom.drives.map(drive => (
        <div key={drive.cdromKey} className="cdrom-drive-row">
          <div className="cdrom-drive-label">
            <span className="cdrom-key">{drive.cdromKey.toUpperCase()}</span>
            <span className="cdrom-current">
              {drive.currentISO ? drive.currentISO.split('/').pop() : <em>Sem mídia</em>}
            </span>
          </div>
          <div className="cdrom-controls">
            <select
              className="cdrom-select"
              value={selectedISOs[drive.cdromKey] ?? ''}
              onChange={e => onSelectISO(drive.cdromKey, e.target.value)}
              disabled={cdromLoading === drive.cdromKey}
            >
              <option value="">— Sem mídia —</option>
              {cdrom.isos.map(iso => (
                <option key={iso.volid} value={iso.volid}>{iso.name}</option>
              ))}
            </select>
            <button
              className="action-btn cdrom-insert"
              onClick={() => onApply(drive.cdromKey, selectedISOs[drive.cdromKey])}
              disabled={!!cdromLoading || selectedISOs[drive.cdromKey] === (drive.currentISO || '')}
            >
              {cdromLoading === drive.cdromKey ? '...' : '💿 Inserir'}
            </button>
            {drive.currentISO && (
              <button
                className="action-btn cdrom-eject"
                onClick={() => {
                  onSelectISO(drive.cdromKey, '');
                  onApply(drive.cdromKey, '');
                }}
                disabled={!!cdromLoading}
              >
                ⏏ Ejetar
              </button>
            )}
          </div>
        </div>
      ))}
      {cdromMsg && (
        <div className={`cdrom-msg ${cdromMsg.type}`}>{cdromMsg.text}</div>
      )}
    </div>
  );
}

export default VMCDROMPanel;
